import type { MiniInterviewType } from 'src/packages/polaris/types';

type GetIntroMessageOptions = {
  interviewType: MiniInterviewType | null;
  conditionName?: string;
};

function getIntroMessage({ interviewType, conditionName }: GetIntroMessageOptions) {
  switch (interviewType) {
    case 'emergency':
      return `Buoy's clinically-backed AI has identified various emergency scenarios related to ${conditionName}. We’ll ask a few questions to determine if any of those scenarios apply to you.`;
    case 'symptoms':
      return `Buoy's clinically-backed AI will ask up to 20 questions to determine the top most likely causes of your ${conditionName}.`;
    default:
      return '';
  }
}

export default getIntroMessage;
